import React, { useMemo } from 'react';
import SiteCharts from '../../../components/SiteCharts';
import { sgNbAdditionNrCellChartConfig } from '../cellChartConfigs';

/**
 * Props for the SgNbAdditionNrCell component
 */
interface SgNbAdditionNrCellProps {
  /** Name of the NR cell */
  cellName: string;
  /** Callback function to toggle fullscreen mode */
  onFullscreenToggle: () => void;
  /** Current fullscreen state */
  isFullscreen: boolean;
}

/**
 * SgNB Addition Success Rate Chart (NR Cell Level)
 * 
 * Displays Secondary gNodeB addition metrics for EN-DC in individual NR cells:
 * - SgNB Addition Success (count)
 * - SgNB Addition Attempt (count)
 * - SgNB Addition Success Rate (percentage)
 * 
 * @component
 * @see {@link ../cellChartConfigs.ts} - Chart configuration (sgNbAdditionNrCellChartConfig)
 * @see API: /api/nr/cell/sgnb-addition?cell_name={cellName}
 */
const SgNbAdditionNrCell: React.FC<SgNbAdditionNrCellProps> = ({ 
  cellName, 
  onFullscreenToggle, 
  isFullscreen 
}) => {
  // Memoize additionalParams to prevent infinite re-renders
  const additionalParams = useMemo(() => ({ cell_name: cellName }), [cellName]);

  return (
    <SiteCharts 
      config={sgNbAdditionNrCellChartConfig}
      onFullscreenToggle={onFullscreenToggle}
      isFullscreen={isFullscreen}
      additionalParams={additionalParams}
    />
  );
};

export default SgNbAdditionNrCell;
